module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s04-ttl_s-f4574cee4b7cbcb8db36acdcc238e9bd.png";